// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wj-8";
export var editMode = "_wj-3";
export var headerRow = "_wj-a";
export var headerTitle = "_wj-b";
export var product = "_wj-1";
export var productDetails = "_wj-5";
export var productDivider = "_wj-7";
export var productImage = "_wj-2";
export var productInfo = "_wj-4";
export var productTitle = "_wj-6";
export var strikethrough = "_wj-9";
export var upsellProductsCard = "_wj-0";